// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-jC0B-";
var _4 = "button-htD3V";
var _5 = "button__icon-268Tq";
var _6 = "cancel-1C4r8";
var _7 = "sendToEmailButton-3eu_-";
var _8 = "sendToEmailButton_disabled-xuM8F";
var _9 = "disabled-2vNha";
var _a = "scrollBody-2HiOn";
var _b = "paper-1aZEw";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "button", _5 as "button__icon", _6 as "cancel", _7 as "sendToEmailButton", _8 as "sendToEmailButton_disabled", _9 as "disabled", _a as "scrollBody", _b as "paper" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "button": _4, "button__icon": _5, "cancel": _6, "sendToEmailButton": _7, "sendToEmailButton_disabled": _8, "disabled": _9, "scrollBody": _a, "paper": _b }
